import React, {useEffect, useMemo, useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PeopleIcon from '@material-ui/icons/People';

import PoliciesService from "../../../services/PoliciesService";

//import table components
import FuneralEnhancedTable from "./FuneralClientsTableComponent/EnhancedTable";
import SavingsEnhancedTable from "./SavingsClientsTableComponent/EnhancedTable";
import AccidentsEnhancedTable from "./AccidentClientsTableComponent/EnhancedTable";
import ComprehensiveEnhancedTable from "./ComprehensiveClientsTableComponent/EnhancedTable";
import PfumaEnhancedTable from "./PfumaClientsTableComponent/EnhancedTable";
import CssBaseline from "@material-ui/core/CssBaseline";
import {Link, useHistory} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import Spinner from "reactjs-simple-spinner";


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    indicator: {
        color: "#64c3c2"
    }
}));

const Policies = () => {
    let history = useHistory();

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [accData, setAccData] = useState([]);
    const [compData, setCompData] = useState([]);
    const [funData, setFunData] = useState([]);
    const [savData, setSavData] = useState([]);
    const [pfumaData, setPfumaData] = useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const accColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Payment Frequency',
                accessor: 'payment_frequency',
            },
            {
                Header: 'Payment',
                accessor: 'payment_method',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured'
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },
            {
                Header: 'Status',
                accessor: 'policy_status'
            },

        ],
        []
    )


    const funColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Payment Frequency',
                accessor: 'payment_frequency',
            },
            {
                Header: 'Payment',
                accessor: 'payment_method',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured'
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },
            {
                Header: 'Status',
                accessor: 'policy_status'
            }

        ],
        []
    )

    const compColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Payment Frequency',
                accessor: 'payment_frequency',
            },
            {
                Header: 'Payment',
                accessor: 'payment_method',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured'
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },
            {
                Header: 'Status',
                accessor: 'policy_status'
            },

        ],
        []
    )

    const savColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Payment Frequency',
                accessor: 'payment_frequency',
            },
            {
                Header: 'Payment',
                accessor: 'payment_method',
            },
            {
                Header: 'Premium',
                accessor: 'premium'
            },
            {
                Header: 'Sum Assured',
                accessor: 'sum_assured'
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },
            {
                Header: 'Status',
                accessor: 'policy_status'
            },

        ],
        []
    )

    const pfumaColumns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Payment Frequency',
                accessor: 'payment_frequency',
            },
            {
                Header: 'Payment',
                accessor: 'payment_method',
            },
            {
                Header: 'Policy Status',
                accessor: 'policy_status',
            },
            {
                Header: 'Contract Premium',
                accessor: 'total_premium',
            },
            {
                Header: 'Policy Type',
                accessor: 'policy_type',
            },
            {
                Header: 'Policy Currency',
                accessor: 'policy_currency',
            },
            {
                Header: 'Commencement Date',
                accessor: 'commencement_date'
            },

        ],
        []
    )

    //view PolicyHolder
    const viewPolicy = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('policyNumber', JSON.stringify(value));
        history.push('/view-policy');
    }


    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setAccData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }
    const updateMyCompData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setCompData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const updateMyFunData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setFunData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const updateMySavData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setSavData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const updatePfumaData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setPfumaData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        //get accClients
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        //    get allPolicies
        PoliciesService.getAllPolicies()
            .then(response => {
                if (response.status === 200) {
                    let d = [];
                    let c = [];
                    let f = [];
                    let s = [];
                    let p = [];

                    console.log("res: ", response.data.policies)
                    response.data.policies.map((i, x) => {
                        if (i.policy_type === "ACCIDENT") {
                            d.push(i);
                            setAccData(d)
                        } else if (i.policy_type === "COMPREHENSIVE") {
                            c.push(i);
                            setCompData(c)
                        } else if (i.policy_type === "FUNERAL") {
                            f.push(i);
                            setFunData(f)
                        } else if (i.policy_type === "SAVINGS") {
                            s.push(i);
                            setSavData(s)
                        } else if (i.policy_type === "PFUMA / INOTHO") {
                            p.push(i);
                            setPfumaData(p)
                        }
                    })
                    setLoading(false)
                } else {
                    setAccData([])
                    setFunData([])
                    setCompData([])
                    setSavData([])
                    setPfumaData([])
                    setLoading(false)
                }

            }).catch(err => {
            console.error(err)
            setAccData([])
            setFunData([])
            setCompData([])
            setSavData([])
            setPfumaData([])
            setLoading(false)
        })

    }, []);

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>

            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Clients</span>
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait,Good things takes time....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="col-lg-12">
                                    <Paper className={classes.root}>
                                        <Tabs value={value}
                                              onChange={handleChange}
                                              indicatorColor="primary"
                                              textColor="primary"
                                              centered
                                        >
                                            <Tab icon={<PeopleIcon/>} label="Accident Clients" {...a11yProps(0)} />
                                            <Tab icon={<PeopleIcon/>}
                                                 label="Comprehensive Funeral Clients" {...a11yProps(1)} />
                                            <Tab icon={<PeopleIcon/>}
                                                 label="Standard Funeral Clients" {...a11yProps(2)} />
                                            <Tab icon={<PeopleIcon/>} label="Savings Clients" {...a11yProps(3)} />
                                            <Tab icon={<PeopleIcon/>}
                                                 label="Pfuma / Inotho Clients" {...a11yProps(4)} />
                                        </Tabs>

                                        <TabPanel value={value} index={0}>
                                            <div id="table">
                                                <CssBaseline/>
                                                <AccidentsEnhancedTable
                                                    columns={accColumns}
                                                    data={accData}
                                                    setData={setAccData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel value={value} index={1}>
                                            <div id="table">
                                                <CssBaseline/>
                                                <ComprehensiveEnhancedTable
                                                    columns={compColumns}
                                                    data={compData}
                                                    setData={setCompData}
                                                    updateMyData={updateMyCompData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel value={value} index={2}>
                                            <div id="table">
                                                <CssBaseline/>
                                                <FuneralEnhancedTable
                                                    columns={funColumns}
                                                    data={funData}
                                                    setData={setFunData}
                                                    updateMyData={updateMyFunData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel value={value} index={3}>
                                            <div id="table">

                                                <CssBaseline/>
                                                <SavingsEnhancedTable
                                                    columns={savColumns}
                                                    data={savData}
                                                    setData={setSavData}
                                                    updateMyData={updateMySavData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel value={value} index={4}>
                                            <div id="table">

                                                <CssBaseline/>
                                                <PfumaEnhancedTable
                                                    columns={pfumaColumns}
                                                    data={pfumaData}
                                                    setData={setPfumaData}
                                                    updateMyData={updatePfumaData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </TabPanel>
                                    </Paper>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Policies;
